//termino
export const frequency_unit = [
	{
		value: 'mensual',
		cod: 1645,
	},
	{
		value: 'anual',
		cod: 1070,
	},
];

//categoria
export const category_unit = [
	{
		value: 'basico',
		cod: 1,
	},
	{
		value: 'premium',
		cod: 2,
	},
	{
		value: 'intermedio',
		cod: 3,
	},
];

export const duration = [
	{
		value: 'una vez',
		cod: 'once',
	},
	{
		value: 'varios meses',
		cod: 'repeating',
	},
];


export const role = {
	TUTOR: 1712,
	PARENT: 2298,
	TEACHER: 2929,
	STUDENT: 3075,
	DIRECTOR: 3936,
	HELP_DESK: 4493,
	LOGISTICS: 4892,
	ACCOUNTING: 5953,
	ADMIN_CLIENT: 7978,
	ADMIN_DREYFOUS: 11180,
	ACCOUNT_MANAGER: 12241,
	ASSITANT_CLIENT: 12388,
	ADMIN_HOMESCHOOLER: 17992,
};

const enumsByName = {
	frequency_unit,
	category_unit,
	duration,
	role
}

type EnumName = keyof typeof enumsByName

export default function getName(enumName:EnumName, code:Number) {
	const targetEnum = enumsByName[enumName]	
	if (!targetEnum) return undefined 
	if (Array.isArray(targetEnum)) {
		const item = targetEnum.find(({cod}) => cod === code)
		if (item) {
			return item.value
		}
	}
	const [name] = Object.entries(targetEnum).find(([_, cod]) => cod === code) || []
	return name
}